<template>
  <!-- Dialog Logout -->
  <ib-dialog
    :visible="visible"
    :show-close="false"
    top="8vh"
    width="340px"
    empty-header
    @close="closeDialogLogout"
  >
    <!-- Dialog Content -->
    <ib-dialog-confirmation-content
      :image="require('@/assets/img/illustrations/log-out.svg')"
      :title="$t('dialogs.logout.title')"
      title-width="230px"
    />
    <!-- /Dialog Content -->

    <!-- Dialog Footer -->
    <template #footer>
      <ib-divider block class="mb-4" />
      <ib-dialog-footer
        button-size="md"
        :submit-btn-text="$t('yes')"
        :cancel-btn-text="$t('cancel')"
        @cancel="closeDialogLogout"
        @submit="logout"
      />
    </template>
    <!-- /Dialog Footer -->
  </ib-dialog>
  <!-- /Dialog Logout -->
</template>

<script>
export default {
  name: 'DialogLogout',

  props: {
    visible: Boolean
  },

  methods: {
    closeDialogLogout () {
      this.$emit('close')
    },

    logout () {
      this.$cookies.remove('access_token')
      this.$http.defaults.headers.common['X-Authorization'] = null
      localStorage.removeItem('persisted_state')
      this.$intercom.shutdown()
      this.$store.dispatch('resetState')
      this.$router.push({ name: 'login' })
    }
  }
}
</script>
